import { createContext } from 'react'

import { Summary } from './types'

type SummaryManagerType = {
  summary: Summary
}

const defaultValue = {
  summary: {},
}

const SummaryManager = createContext<SummaryManagerType>(defaultValue)

export default SummaryManager
